/* WildMelt homepage — tabs + carousels. Custom elements tự khởi tạo lại khi section được tải lại trong theme editor. */
(function(){
  if(!customElements.get('wm-tabs')){
    customElements.define('wm-tabs',class extends HTMLElement{
      connectedCallback(){
        const tabs=[...this.querySelectorAll('[role="tab"]')];
        const select=t=>tabs.forEach(x=>{const on=x===t;x.setAttribute('aria-selected',on);x.tabIndex=on?0:-1;const p=this.querySelector('#'+x.getAttribute('aria-controls'));if(p)p.hidden=!on;});
        tabs.forEach((t,i)=>{
          t.addEventListener('click',()=>select(t));
          t.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){const n=tabs[(i+(e.key==='ArrowRight'?1:tabs.length-1))%tabs.length];select(n);n.focus();}});
        });
        if(tabs.length) select(tabs.find(t=>t.getAttribute('aria-selected')==='true')||tabs[0]);
      }
    });
  }
  if(!customElements.get('wm-scroller')){
    customElements.define('wm-scroller',class extends HTMLElement{
      connectedCallback(){
        const track=this.querySelector('[data-track]'); if(!track) return;
        const step=()=>{const it=track.firstElementChild;return it?it.getBoundingClientRect().width*2:300;};
        const prev=this.querySelector('[data-prev]'), next=this.querySelector('[data-next]');
        prev&&prev.addEventListener('click',()=>track.scrollBy({left:-step(),behavior:'smooth'}));
        next&&next.addEventListener('click',()=>track.scrollBy({left:step(),behavior:'smooth'}));
      }
    });
  }
})();
